<template>
  <div class="no-internet-connection">
    <img :src="imageSrc" />
    <div class="no-internet-connection-title">
      {{ props.title }}
    </div>
    <div class="no-internet-connection-text">
      {{ props.text }}
    </div>

    <slot v-if="showButton" name="button">
      <button v-ripple class="button-retry" @click="emit('retry')">
        Tentar novamente
      </button>
    </slot>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

interface Emits {
  (e: 'retry'): void;
}
const emit = defineEmits<Emits>();

export type Props = {
  title?: string | undefined;
  text?: string | undefined;
  kind?: 'internet' | 'update' | 'success' | 'unknown' | 'default';
  showButton?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  title: 'Hey, parece que você não\n está conectado a internet',
  text: 'Tente carregar novamente,\n caso sua conexão já estiver estabilizada',
  kind: 'default',
  showButton: true,
});

const imageSrc = computed(
  () =>
    ({
      internet: '/images/alerts/circle-internet-disconnect.svg',
      update: '/images/alerts/circle-update-app.svg',
      unknown: '/images/alerts/circle-dislike-red.svg',
      default: '/images/alerts/circle-alert-red.svg',
      success: '/images/alerts/circle-like-green.svg',
    }[props.kind]),
);
</script>

<style scoped>
.no-internet-connection {
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  max-width: 250px;
}
.no-internet-connection-title {
  color: var(--color-neutral-06);
  font-size: 20px;
  font-weight: 500;
  line-height: 120%;
  margin-bottom: 12px;
  margin-top: 32px;
}
.no-internet-connection-text {
  color: var(--color-neutral-05);
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 32px;
  line-height: 120%;
}
.button-retry {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  background-color: var(--color-brand-03);
  color: var(--color-contrast-oninteractive);
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  border-radius: 9999px;
  font-size: 0.875rem;
}
</style>
